<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Batch Scheme` : "Add Batch Scheme" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6"
            ><v-autocomplete
              v-model.trim="filter_program_batch"
              label="Programme*"
              :items="program_batches"
              item-text="name"
              item-value="id"
              outlined
              dense
              bottom
              hide-details="auto"
              return-object
              @change="getProgramSchemes"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model.trim="form.program_scheme_id"
              label="Programme Scheme*"
              :disabled="!filter_program_batch"
              :items="program_schemes"
              item-text="name"
              item-value="id"
              outlined
              dense
              bottom
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6"
            ><v-autocomplete
              v-model.trim="form.partner_id"
              label="Partner*"
              :items="partners"
              item-text="name"
              item-value="id"
              outlined
              dense
              bottom
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    batch_scheme: {
      type: Object,
      default: () => {},
    },
    programs: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {},
      program_schemes: [],
      partners: [],
      years: Array.from({ length: 15 }, (v, k) => k + new Date().getFullYear()),
      program_batches: [],
      filter_program_batch: null,
    };
  },
  watch: {
    program_schemes(val) {
      if (val.length === 1) {
        this.form.program_scheme_id = val[0].id;
      } else if (!val.find((item) => item.id === this.form.program_scheme_id)) {
        this.form.program_scheme_id = null;
      }
    },
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.getProgramBatches();
      this.getPartners();
      if (this.edit) {
        this.form = { ...this.batch_scheme };
      }
    },

    save() {
      this.form.program_batch_id = this.filter_program_batch.id;
      if (this.$refs.form.validate()) {
        this.$emit(this.edit ? "update" : "create", this.form);
      }
    },
    getProgramSchemes() {
      this.$axios
        .get(
          `program_schemes?program_id=${this.filter_program_batch.program_id}&status=Published`,
        )
        .then((res) => {
          this.program_schemes = res.data.data;
        });
    },
    getPartners() {
      this.$axios.get(`partners`).then((res) => {
        this.partners = res.data.data;
      });
    },
    async getProgramBatches() {
      await this.$axios.get(`/program_batches`).then((res) => {
        this.program_batches = res.data.data;
        if (this.edit) {
          this.filter_program_batch = this.program_batches.find(
            (item) => item.id === this.form.program_batch_id,
          );
          this.getProgramSchemes();
        }
        console.log(this.program_batches);
      });
    },
  },
};
</script>

<style scoped></style>
